module.exports = __webpack_public_path__ + "static/img/11.369d2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/11.png
// module id = 0/uy
// module chunks = 1